<div class="main-popup mt-5">
    <div class="main-title-popup mb-3">
        <h1>Vaccination Program</h1>
        <p>Details for vaccination program</p>
    </div>

    <form [formGroup]="vaccinationForm" (ngSubmit)="onSave()">
        <div formArrayName="vaccines">
            <div *ngFor="let vaccine of vaccines.controls; let i = index" [formGroupName]="i"
                class="vaccine-entry p-3 rounded">
                <div class="row">
                    <!-- Vaccine Brand -->
                    <div class="col-md-6 formGroup">
                        <label for="brand-{{ i }}">
                            Vaccine Brand
                            <span class="text-danger-required">*</span>
                        </label>
                        <select id="brand-{{ i }}" formControlName="brandId" class="form-control">
                            <option value="">Select</option>
                            <option *ngFor="let brand of brands" [value]="brand.id">
                                {{ brand.brand }}
                            </option>
                        </select>
                        <div *ngIf="
                                vaccine.get('brandId').invalid &&
                                vaccine.get('brandId').touched
                            " class="text-danger">
                            Please select Brand.
                        </div>
                    </div>

                    <!-- Vaccine Type -->
                    <div class="col-md-6 formGroup">
                        <label for="type-{{ i }}">
                            Vaccine Type
                            <span class="text-danger-required">*</span>
                        </label>
                        <select id="type-{{ i }}" formControlName="chicksTypeId" class="form-control">
                            <option value="">Select</option>
                            <option *ngFor="let type of chickstypes" [value]="type.id">
                                {{ type.name }}
                            </option>
                        </select>
                        <div *ngIf="
                                vaccine.get('chicksTypeId').invalid &&
                                vaccine.get('chicksTypeId').touched
                            " class="text-danger">
                            Please select Vaccine Type.
                        </div>
                    </div>
                </div><!-- House Vaccination Section -->
                <div class="house-selection-section mt-4">
                
                    <!-- House Multi Select -->
                    <div class="row mt-3">

                        <div class="col-md-12 formGroup p-multiSelect-custom">

                            <label for="houses-{{ i }}">
                                Select Houses
                                <span class="text-danger-required">*</span>
                            </label>

                            <p-multiSelect
                                formControlName="houseIds"
                                [options]="houses"
                                optionLabel="houseName"
                                optionValue="houseId"
                                [placeholder]="'Select Houses'"
                                [showToggleAll]="false"
                                [filter]="true"
                                defaultLabel="Select Houses"
                                panelStyleClass="hide-close-btn"
                                (onChange)="onHouseSelectionChange($event, i)"
                            >
                            </p-multiSelect>

                            <div
                                *ngIf="
                                    vaccine.get('houseIds')?.invalid &&
                                    vaccine.get('houseIds')?.touched
                                "
                                class="text-danger mt-1"
                            >
                                Please select at least one house.
                            </div>

                        </div>

                    </div>

                    <!-- Selected House Rows -->
                    <div
                        formArrayName="houseVaccinations"        
                    >

                        <div
                            *ngIf="getHouseVaccinations(i).controls.length > 0"
                            class="selected-house-title mb-3"
                        >
                    </div>

                        <div
                            *ngFor="
                                let house of getHouseVaccinations(i).controls;
                                let j = index
                            "
                            [formGroupName]="j"
                            class="selected-house-card row align-items-center mb-3"
                        >

                            <!-- House Name -->
                            <div class="col-md-6 formGroup">

                                <label>
                                    House Name
                                </label>

                                <input
                                    type="text"
                                    class="form-control house-readonly-input"
                                    formControlName="houseName"
                                    readonly
                                />

                            </div>

                            <!-- Birds Vaccinated -->
                            <div class="col-md-6 formGroup">

                                <label>
                                    Birds Vaccinated
                                </label>

                                <input
                                    type="number"
                                    class="form-control"
                                    formControlName="birdsVaccinated"
                                    placeholder="Enter birds vaccinated"
                                />

                            </div>

                        </div>

                    </div>

                </div>
                <!-- Quantity + Application Date -->
                <div class="row mt-2">
                    <!-- Quantity (Box) -->
                    <div class="col-md-6 formGroup">
                        <label for="quantity-{{ i }}">
                            Quantity (Box)
                            <span class="text-danger-required">*</span>
                        </label>
                        <input type="number" id="quantity-{{ i }}" formControlName="quantity" class="form-control"
                            placeholder="Enter quantity" min="1" />
                        <div *ngIf="
                                vaccine.get('quantity').invalid &&
                                vaccine.get('quantity').touched
                            " class="text-danger">
                            Please enter a valid quantity.
                        </div>
                    </div>

                    <!-- Application Date -->
                    <div class="col-md-6 formGroup">
                        <label for="applicationDate-{{ i }}">
                            Application Date
                            <span class="text-danger-required">*</span>
                        </label>
                        <input type="datetime-local" id="applicationDate-{{ i }}" formControlName="applicationDate"
                            class="form-control" />
                        <div *ngIf="
                                vaccine.get('applicationDate').invalid &&
                                vaccine.get('applicationDate').touched
                            " class="text-danger">
                            Please select application date.
                        </div>
                    </div>
                </div>

                <!-- Notes -->
                <div class="row mt-2">
                    <div class="col-md-12 formGroup">
                        <label for="notes-{{ i }}">Notes</label>
                        <textarea id="notes-{{ i }}" formControlName="notes" class="form-control" rows="3"
                            placeholder="Additional notes (optional)"></textarea>
                    </div>
                </div>

                <!-- Delete button -->
                <div class="row mt-2">
                    <div class="col-md-12 text-right">
                        <button type="button" class="btn btn-danger btn-sm" (click)="removeVaccine(i)"
                            [disabled]="vaccines.length <= 1">
                            <i class="fas fa-trash-alt"></i> Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add vaccine button -->
        <div class="row">
            <div class="col-md-12 text-right mt-3">
                <button type="button" class="btn-action" (click)="addVaccine()">
                    <span class="vaccine-plus"><i class="fas fa-plus"></i></span>
                    Add vaccine
                </button>
            </div>
        </div>

        <!-- Submit section -->
        <div class="row">
            <div class="col-md-12 text-center mt-4">
                <button class="btn btn-action-primary" type="submit" [disabled]="isLoading$ | async">
                    <span *ngIf="!isAuthLoading">Submit</span>
                    <span *ngIf="isAuthLoading">Submitting...</span>
                </button>
                <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..."
                    class="loader-image mt-2" />
            </div>
        </div>
    </form>
</div>